export default __webpack_public_path__ + "static/bidra-i-figma1-24ef7a1dea4ac596a371d0e0bd93d791.png";